import { AuthFetchWithResponse } from 'src/Types/api'
import { ApiResult } from '../../api'
import { StatusCodes } from '../../http-status-codes'
import { UnexpectedApiResponseError } from 'src/Libs/errors'
import { UserReferralCodeStatsDto, UserReferralCodeStatsModel, userReferralCodeStatTransformer } from '../transformers'

/**
 * Send a signal to generated referral code
 */
export const generateReferralCode = async (authFetch: AuthFetchWithResponse): Promise<ApiResult<string>> => {
  const response = await authFetch<string>({
    path: `users/c2c-referral-codes`,
    method: 'POST',
    payload: {},
    endpoint: process.env.REACT_APP_API_ENDPOINT,
  })

  if (response.status === StatusCodes.OK) {
    return new ApiResult<string>(response.data, false)
  }

  return new ApiResult<string>(null, true)
}

/**
 * Resend the referral code as email
 * @param authFetch - AuthFetchWithResponse
 * @returns ApiResult
 */
export const resendReferalCode = async (referalCodeId: number, authFetch: AuthFetchWithResponse): Promise<ApiResult<void>> => {
  const response = await authFetch<void>({
    path: `users/c2c-amazon-codes/${referalCodeId}/resend`,
    method: 'POST',
    payload: {},
    endpoint: process.env.REACT_APP_API_ENDPOINT,
  })

  if (response.status === StatusCodes.NO_CONTENT) {
    return new ApiResult<void>(null, false)
  }

  return new ApiResult<void>(null, true)
}

/**
 * Get the number of generated referral codes
 */
export const getUserReferralCodeStats = async (authFetch: AuthFetchWithResponse): Promise<ApiResult<UserReferralCodeStatsModel>> => {
  const response = await authFetch<UserReferralCodeStatsDto>({
    path: `users/c2c-referral-codes/stats`,
    method: 'GET',
    endpoint: process.env.REACT_APP_API_ENDPOINT,
  })

  if (response.status === StatusCodes.OK) {
    const model = userReferralCodeStatTransformer(response.data)
    return new ApiResult<UserReferralCodeStatsModel>(model, false)
  }

  if (response.status === StatusCodes.NO_CONTENT) return new ApiResult<UserReferralCodeStatsModel>(null, true)
  throw new UnexpectedApiResponseError(response.status)
}
